import React, { ReactNode } from 'react';

import { TooltipIcon } from 'common/components/TooltipWithIcon/TooltipWithIcon';
import { AlignItems, FlexDirection, JustifyContent } from 'types/CSS';

import { FormLabel } from '../input-styled-components';

import { LabelText, Subtext, TextStyle, TextWrapper } from './LabeledInput-styled-components';

interface LabeledInputProps {
  label: string | React.JSX.Element;
  subtext?: string;
  children: ReactNode;
  htmlFor?: string;
  tooltip?: string;
  endContent?: ReactNode;
  direction?: FlexDirection;
  alignItems?: AlignItems;
  justifyContent?: JustifyContent;
  textStyle?: TextStyle;
}

export const LabeledInput = ({
  label,
  subtext,
  children,
  htmlFor,
  tooltip,
  endContent,
  direction,
  alignItems,
  justifyContent,
  textStyle,
}: LabeledInputProps) => {
  return (
    <FormLabel
      $direction={direction}
      $alignItems={alignItems}
      $justifyContent={justifyContent}
      htmlFor={htmlFor}
      aria-label={typeof label === 'string' ? label : undefined}
    >
      <TextWrapper $hasEndContent={Boolean(endContent)}>
        <LabelText $textStyle={textStyle}>
          {label}
          {subtext && <Subtext>{subtext}</Subtext>}
          {tooltip && <TooltipIcon>{tooltip}</TooltipIcon>}
        </LabelText>
        {endContent}
      </TextWrapper>
      {children}
    </FormLabel>
  );
};
